import { BaseModel } from './base';

// Enums

export enum ReferralStatus {
  requested = 0,
  trial = 1,
  signedUp = 2,
  paid = 3,
  validated = 4,
  cancelled = 5,
  invalid = 6,
  pending = 7,
}

export const ReferralStatusLabels: Record<ReferralStatus, string> = {
  [ReferralStatus.requested]: 'api.models.referral.invited',
  [ReferralStatus.trial]: 'general.trial',
  [ReferralStatus.signedUp]: 'api.models.referral.signedUp',
  [ReferralStatus.paid]: 'api.models.referral.paid',
  [ReferralStatus.validated]: 'api.models.referral.validated',
  [ReferralStatus.cancelled]: 'general.cancelled',
  [ReferralStatus.invalid]: 'api.models.referral.invalid',
  [ReferralStatus.pending]: 'api.models.referral.pending',
};

// Main Model

export class Referral extends BaseModel {
  idReferral!: number;
  status!: ReferralStatus;

  override objectID(): string | null {
    return this.idReferral?.toString() ?? null;
  }

  get isStatusRequested(): boolean {
    return this.status === ReferralStatus.requested;
  }

  get isStatusTrial(): boolean {
    return this.status === ReferralStatus.trial;
  }

  get isStatusSignedUp(): boolean {
    return this.status === ReferralStatus.signedUp;
  }

  get isStatusValidated(): boolean {
    return this.status === ReferralStatus.validated;
  }

  get isStatusCancelled(): boolean {
    return this.status === ReferralStatus.cancelled;
  }

  get isStatusPaid(): boolean {
    return this.status === ReferralStatus.paid;
  }

  get isStatusInvalid(): boolean {
    return this.status === ReferralStatus.invalid;
  }

  get isStatusPending(): boolean {
    return this.status === ReferralStatus.pending;
  }
}
